import { render, staticRenderFns } from "./EuropeanCart.vue?vue&type=template&id=45baed04&scoped=true"
import script from "./EuropeanCart.vue?vue&type=script&lang=js"
export * from "./EuropeanCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45baed04",
  null
  
)

export default component.exports